import service from '@/services/SICUDgpd_lab_crd';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_lab_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_lab_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                crd_emp: event.step5.empresa,
                crd_emp_ciu: event.step5.ciudadEmpresa?.[0].ciu__cod || event.step5.ciudadEmpresa,
                crd_ing_emp: event.step5.fechaIngreso,
                crd_niv: event.step5.nivelEducativo?.[0]?.edu__cod || event.step5.nivelEducativo,
                crd_prof: event.step5.profesion?.[0]?.prof__cod || event.step5.profesion,
                crd_cgo: event.step5.cargo,
                prof_nom: event.step5.profesion?.[0]?.prof__des || event.step5.profesion,
                crd_act: event.step5.crd_act?.[0]?.lis_det_par || event.step5.crd_act,
              },
            ],
          },
        };

        let notification;

        service[event?.method || 'post'](payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_lab_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_lab_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
